import httpClient from '../http/http-client';
import { ISurveyResolveResponse, ISurveyResponseItem } from './survey.model';

export default class SurveyPublicService {
  http;

  constructor() {
    this.http = httpClient;
  }

  async resolve(params: { inviteToken?: string; openLinkToken?: string }): Promise<ISurveyResolveResponse> {
    const query = params.inviteToken
      ? `?inviteToken=${params.inviteToken}`
      : `?openLinkToken=${params.openLinkToken}`;
    return this.http.get(`survey-public/resolve${query}`)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  async startSession(body: { inviteToken?: string; openLinkToken?: string; respondentEmail?: string; respondentName?: string }): Promise<{ sessionId: string; sessionToken: string }> {
    return this.http.post('survey-public/start', body)
      .then(response => response.data)
      .catch(err => { console.log(err); throw err; });
  }

  /** Saved answers for an in-progress session, so a respondent who closed the tab can resume. */
  async getAnswers(sessionToken: string): Promise<{
    sessionId: string;
    items: ISurveyResponseItem[];
    productResponses?: { capitalGoodId: string; unitAmount: number; measurementUnitId: string; kgCarbonEmission: number }[];
  }> {
    return this.http.get('survey-public/answers', {
      headers: { 'x-session-token': sessionToken },
    }).then(response => response.data);
  }

  async saveAnswers(sessionToken: string, answers: ISurveyResponseItem[]): Promise<void> {
    return this.http.post('survey-public/answers', answers, {
      headers: { 'x-session-token': sessionToken },
    })
      .then(() => undefined)
      .catch(err => { console.log(err); throw err; });
  }

  async submitSurvey(sessionToken: string): Promise<void> {
    return this.http.post('survey-public/submit', {}, {
      headers: { 'x-session-token': sessionToken },
    })
      .then(() => undefined)
      .catch(err => { console.log(err); throw err; });
  }
  async saveProductAnswers(sessionToken: string, answers: import('./survey.model').ISurveyProductAnswer[]): Promise<void> {
    return this.http.post(`survey-public/product-answers`, answers, { headers: { 'x-session-token': sessionToken } })
      .then(() => undefined)
      .catch(err => { console.log(err); throw err; });
  }

}
